module.exports = __webpack_public_path__ + "img/jumpRight5.dfccd21d.png";